/**
 * Main Password - Sakura petals generator
 * Creates falling sakura petals in each .neptunz-password__petals container.
 * Petal count adapts to screen size (desktop: 22, mobile: 12).
 * Re-inits on shopify:section:load for the theme customizer.
 */
(function () {
  // Désactive la restauration de scroll du navigateur pour que le form POST ne scroll pas sur la zone du form.
  if ('scrollRestoration' in history) {
    history.scrollRestoration = 'manual';
  }

  function petalCount() {
    return window.innerWidth <= 600 ? 12 : 22;
  }

  function createPetals(container) {
    if (!container) return;
    if (container.dataset.petalsReady === 'true') return;
    container.innerHTML = '';
    var count = petalCount();
    for (var i = 0; i < count; i++) {
      var p = document.createElement('div');
      p.className = 'neptunz-password__petal';
      p.style.left = Math.random() * 100 + '%';
      p.style.animationDuration = (8 + Math.random() * 12) + 's';
      p.style.animationDelay = (-Math.random() * 15) + 's';
      p.style.transform = 'rotate(' + (Math.random() * 360) + 'deg)';
      p.style.opacity = 0.35 + Math.random() * 0.45;
      var size = (8 + Math.random() * 10) + 'px';
      p.style.width = size;
      p.style.height = size;
      container.appendChild(p);
    }
    container.dataset.petalsReady = 'true';
  }

  function initAll() {
    document.querySelectorAll('[data-neptunz-password-petals]').forEach(createPetals);
  }

  // Step 2 est rendu après POST : le navigateur peut scroller sur la zone du form et cacher le logo. On force le scroll en haut.
  function scrollTopIfStep2() {
    if (document.querySelector('.neptunz-password__fade-up')) {
      window.scrollTo(0, 0);
    }
  }

  // Meta Pixel Lead — fire une seule fois par session quand l'étape 2 est rendue (inscription newsletter réussie).
  // Payload anonyme : pas d'email transmis. Dedup via sessionStorage pour qu'un F5 sur l'étape 2 ne compte pas comme un nouveau lead.
  function fireMetaLead() {
    var el = document.querySelector('[data-meta-fire-lead]');
    if (!el) return;
    try {
      if (sessionStorage.getItem('neptunz_pwd_lead_fired') === '1') return;
    } catch (e) { /* sessionStorage indispo (mode privé) → on track quand même */ }
    if (typeof window.fbq !== 'function') return;
    window.fbq('track', 'Lead', {
      content_name: 'Newsletter Password Page',
      content_category: el.getAttribute('data-meta-fire-lead') || 'en'
    });
    try { sessionStorage.setItem('neptunz_pwd_lead_fired', '1'); } catch (e) {}
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
      scrollTopIfStep2();
      fireMetaLead();
    });
  } else {
    initAll();
    scrollTopIfStep2();
    fireMetaLead();
  }

  // Le navigateur peut re-scroller après DOMContentLoaded (restauration auto, load, etc). On re-force au load et juste après.
  window.addEventListener('load', scrollTopIfStep2);

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      var section = document.getElementById('shopify-section-' + e.detail.sectionId);
      if (!section) return;
      var containers = section.querySelectorAll('[data-neptunz-password-petals]');
      containers.forEach(function (c) {
        c.dataset.petalsReady = 'false';
        createPetals(c);
      });
    });
  }
})();
